var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 5,
    height: 9,
    rx: 1,
    fill: "#1e293b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 7,
    width: 5,
    height: 15,
    rx: 1,
    fill: "#1e293b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 10,
    width: 5,
    height: 12,
    rx: 1,
    fill: "#1e293b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandingsIcon);
export default __webpack_public_path__ + "static/media/standings-icon.c74d07c4e3c2b4321b2a8084bf8b6011.svg";
export { ForwardRef as ReactComponent };